// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__20xKI","title":"Info_title__1h8Mz","links":"Info_links__1Sy2s","link":"Info_link__13Krb","logo":"Info_logo__2ud1b"};